import { createContext } from 'react';

// Provided by app/ThemeModeProvider; lives in shared/ so shared components can read it.
// Options live in shared/constants/theme.
export const ThemeModeContext = createContext({
  mode: 'system',
  resolvedMode: 'light',
  setMode: () => null,
  toggleMode: () => null,
  themeFamily: 'cool',
  setThemeFamily: () => null,
  previewThemeFamily: () => null,
  tier: 'mid',
  setTier: () => null,
  // { [family]: { well, border, accent } } for the active scheme and tier.
  themeFields: {},
});

export default ThemeModeContext;
